import { render } from "./DialogBubble.vue?vue&type=template&id=5bfe5881&scoped=true"
const script = {}

import "./DialogBubble.vue?vue&type=style&index=0&id=5bfe5881&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bfe5881"]])

export default __exports__